import _initializerDefineProperty from "@babel/runtime/helpers/initializerDefineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _applyDecoratedDescriptor from "@babel/runtime/helpers/applyDecoratedDescriptor";
import _initializerWarningHelper from "@babel/runtime/helpers/initializerWarningHelper";
var _dec, _class, _descriptor, _descriptor2;
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import Collection from 'core/model/Collection';
import { action, observable } from 'mobx';
/**
 * This represents a "View" belonging to a Collection, allowing us to expose a subset of Collection data without modifying
 * the parent Collection at all.
 *
 * @constructor
 * @class
 */
export var ViewCollection = (_dec = observable.ref, _class = /*#__PURE__*/function (_Collection) {
  /**
   * @param data generally this should be filtered data, though you might alternatively perform filtering after instantiation.
   * @param parentCollection
   * @param options options for creating the Collection.
   */
  function ViewCollection(data, parentCollection) {
    var _this;
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    _classCallCheck(this, ViewCollection);
    _this = _callSuper(this, ViewCollection, [data, options]);
    _initializerDefineProperty(_this, "parentCollection", _descriptor, _this);
    /**
     * This is the main reason this class exists in the first place - we need to propagate changes in the View back into the parent.
     */
    _initializerDefineProperty(_this, "remove", _descriptor2, _this);
    _this.parentCollection = parentCollection;
    return _this;
  }
  _inherits(ViewCollection, _Collection);
  return _createClass(ViewCollection, [{
    key: "url",
    get: function get() {
      console.error('Illegal attempt to fetch from a ViewCollection');
      return '';
    }
  }, {
    key: "model",
    get: function get() {
      var _this$parentCollectio;
      return (_this$parentCollectio = this.parentCollection) === null || _this$parentCollectio === void 0 ? void 0 : _this$parentCollectio.model;
    }
  }]);
}(Collection), _descriptor = _applyDecoratedDescriptor(_class.prototype, "parentCollection", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "remove", [action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this2 = this;
    return function (ids, destroyModels) {
      _this2.parentCollection.remove(ids, destroyModels);
    };
  }
}), _class);